import type { CSSProperties, ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  padded?: boolean;
  className?: string;
  style?: CSSProperties;
}

export default function Card({
  children,
  padded = true,
  className = "",
  style,
}: CardProps) {
  return (
    <div
      className={className}
      style={{
        backgroundColor: "var(--ish-bg-card, #fff)",
        border: "1px solid var(--ish-border)",
        borderRadius: 16,
        boxShadow: "0 2px 8px rgba(61, 35, 18, 0.04)",
        ...(padded ? { padding: 16 } : {}),
        ...style,
      }}
    >
      {children}
    </div>
  );
}
